import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type React from "react";
import { QuestScene } from "@/components/blocks/scenes/QuestScene";
import { Reveal } from "@/components/motion/motion";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n/use-i18n";
import { displayH2, Overline } from "./SectionHeading";

/**
 * Points to a case study as the proof attached to an offer (Questovery by
 * default). Meant for a night section.
 */
export function ProofCard({
	label,
	title,
	description,
	link,
	note,
	to = "/{-$locale}/realisations/questovery",
	visual = <QuestScene />,
}: {
	label: string;
	title: string;
	description: string;
	link: string;
	note: string;
	to?:
		| "/{-$locale}/realisations/questovery"
		| "/{-$locale}/realisations/chouic";
	visual?: React.ReactNode;
}) {
	const { localeParams } = useI18n();

	return (
		<div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)] lg:gap-20">
			<Reveal className="space-y-6">
				<Overline>{label}</Overline>
				<h2 className={displayH2}>{title}</h2>
				<p className="max-w-xl text-lg text-pretty text-muted-foreground">
					{description}
				</p>
				<Button variant="outline" size="lg" asChild>
					<Link to={to} params={localeParams}>
						{link}
						<ArrowRight />
					</Link>
				</Button>
				<p className="max-w-xl border-t pt-6 text-sm text-pretty text-muted-foreground">
					{note}
				</p>
			</Reveal>
			<Reveal delay={0.15}>{visual}</Reveal>
		</div>
	);
}
